import { render, staticRenderFns } from "./wasiat-ekyc.vue?vue&type=template&id=6d313d16&"
import script from "./wasiat-ekyc.vue?vue&type=script&lang=js&"
export * from "./wasiat-ekyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports